<h2
  mat-dialog-title
  [ngStyle]="{
    color: data.filterSettings.textColor,
    background: data.filterSettings.backgroundColor
  }"
>
  {{ 'PERFORMANCE.MULTI_LOCATION.FILTERS.TITLES.GROUP' | translate }}
</h2>
<mat-dialog-content>
  <div class="location-selector">
    <mat-form-field>
      <input matInput cdkFocusInitial [matAutocomplete]="auto" [formControl]="groupControl" />
      <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption (optionSelected)="setGroupOpt($event)">
        @for (option of filteredOptions$ | async; track option) {
          <mat-option [value]="option.name">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="close(false)">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="close(true)">
    {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
